import {Button, Card, Spinner} from "@fluentui/react-components";

function LoginCard({ content, onClick, isLoading, buttonText = null }) {
    return (
        <Card className={`card`}>
            {content}
            <div style={{display: "flex", justifyContent: "flex-end", alignItems: "flex-end"}}>
                <Button as={`a`} className={`button`} appearance="primary" onClick={onClick}>{ isLoading ? <Spinner size={"extra-tiny"}/> : (buttonText == null ? "Doorgaan" : buttonText)}</Button>
            </div>
        </Card>
    );
}

export default LoginCard;